// Components
export { HeroCarouselComponent } from './hero-carousel.component';
// Models
export type { HeroCarouselSlideClickEvent } from './models/hero-carousel-slide-click-event.interface';
export type { HeroCarouselState } from './models/hero-carousel-state.type';
// Config
//export type { HeroCarouselConfig } from './config/hero-carousel.config';
